/*!
 * @copyright
 * Copyright(c) 2018 SICK AG
 */
// tslint:disable:no-bitwise
import { BufferAttribute, PlaneBufferGeometry } from 'three';
const UINT8_MAX = (1 << 8) - 1;
const UINT16_MAX = (1 << 16) - 1;
export class HeightmapBufferGeometry extends PlaneBufferGeometry {
    constructor(width, height, heightValues, getColor) {
        super(1, 1, width - 1, height - 1);
        this.width = width;
        this.height = height;
        this.addAttribute('color', new BufferAttribute(new Float32Array(width * height * 3), 3));
        this.updateValues(heightValues, getColor);
    }
    updateValues(heightValues, getColor) {
        const position = this.getAttribute('position');
        const color = this.getAttribute('color');
        const { width: w, height: h } = this;
        for (let y = 0; y < h; y++) {
            const lineStart = y * w;
            for (let x = 0; x < w; x++) {
                const idx = lineStart + x;
                const depth = heightValues[idx] / UINT16_MAX;
                const col = getColor(idx);
                position.setZ(idx, depth);
                color.setXYZ(idx, col.r, col.g, col.b);
            }
        }
        position.needsUpdate = true;
        color.needsUpdate = true;
    }
}
//# sourceMappingURL=HeightmapBufferGeometry.js.map